import { Box } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useRouter } from 'next/router';
import Typography from '@ui/Typography';
import TypographyLink from '@ui/TypographyLink';
import Button from '@ui/Button';
import PublicShareError from 'components/PublicSharePage/PublicShareError';

export default function ScriptStudioError() {
  const router = useRouter();
  const { classes } = useStyles();
  const handleBack = () => {
    router?.replace('/dashboard');
  };
  return (
    <Box className={classes.container}>
      <PublicShareError includeHelp={false} />
      <Button
        variant="primary"
        onClick={handleBack}
        className={classes.goBackBtn}
      >
        <Typography variant="h4" bold color="gray_1000">
          Back to projects
        </Typography>
      </Button>
      <div className={classes.cta}>
        <Typography variant="pLg" color="secondary">
          If you believe this is an error,
        </Typography>
        <TypographyLink
          variant="pLg"
          href={`mailto:support@wellsaidlabs.com?subject=WellSaid Studio Error Report`}
          color="gray_75"
          underlined
        >
          Contact support
        </TypographyLink>
      </div>
    </Box>
  );
}

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  goBackBtn: {
    width: 'fit-content',
  },
  cta: {
    display: 'flex',
    gap: theme.spacing(0.25),
    marginTop: theme.spacing(12.5),
  },
}));
